import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import AboutSwamiji from '../pages/AboutSwamiji';
import VedanthaClasses from '../pages/VedanthaClasses';
import TamilTalks from '../pages/TamilTalks';
import GeneralTalks from "../pages/GeneralTalks";
import Navbar from '../components/Navbar';
import Footer from "../components/Footer";
import ContactUs from "../pages/ContactUs";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import HelpSupport from '../pages/HelpSupport';
import Discourses from '../pages/Discourses';
import NotFoundPage from '../pages/404';
const AppRouter = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/about-swamiji" element={<AboutSwamiji />} />
        <Route path="/vedanta-classes" element={<VedanthaClasses />} />
        <Route path="/discourses" element={<Discourses />} />
        <Route path="/tamil-talks" element={<TamilTalks />} />
        <Route path="/general-talks" element={<GeneralTalks />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/help-support" element={<HelpSupport />} />
        <Route path="*" element={<NotFoundPage />} /> {/* 404 page route */}
        {/* Add more routes as needed */}
      </Routes>
      <Footer />
    </Router>
  );
};

export default AppRouter;
